var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessages = function SvgMessages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 1.6c-2.387 0-4.676.823-6.364 2.289C1.948 5.354 1 7.34 1 9.413a7.03 7.03 0 0 0 1.172 3.845c.766 1.173 1.869 2.153 3.2 2.846A7.4 7.4 0 0 1 3.8 18.4a9.4 9.4 0 0 0 3.655-1.497c.826.213 1.684.323 2.546.324 2.387 0 4.676-.823 6.364-2.289C18.052 13.473 19 11.486 19 9.413c0-2.072-.948-4.06-2.636-5.524C14.676 2.423 12.387 1.6 10 1.6"
  })));
};
export default SvgMessages;